//
// Module for Add Batch Adjustment
//
rs.module("content/employer/reporting/batchadjustments/add",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            // Unpack js selectors
            var batchAdjustmentForm = $.js(jsSelectors.batchAdjustmentForm);

            var submitButton = batchAdjustmentForm.js(jsSelectors.submitButton, { required: false });
            var loadingSpinner = batchAdjustmentForm.js(jsSelectors.loadingSpinner);
            var adjustMemberContributionsCheckBox = batchAdjustmentForm.js(jsSelectors.adjustMemberContributionsCheckBox, { required: false });
            var memberContributionAmount = batchAdjustmentForm.js(jsSelectors.memberContributionAmount, { required: false });
            var adjustLongevityContributionsCheckBox = batchAdjustmentForm.js(jsSelectors.adjustLongevityContributionsCheckBox, { required: false });
            var longevityContributionAmount = batchAdjustmentForm.js(jsSelectors.longevityContributionAmount, { required: false });
            var adjustEmployerContributionsCheckBox = batchAdjustmentForm.js(jsSelectors.adjustEmployerContributionsCheckBox, { required: false });
            var employerContributionAmount = batchAdjustmentForm.js(jsSelectors.employerContributionAmount, { required: false });
            var adjustEmployerLongevityContributionsCheckBox = batchAdjustmentForm.js(jsSelectors.adjustEmployerLongevityContributionsCheckBox, { required: false });
            var employerLongevityContributionAmount = batchAdjustmentForm.js(jsSelectors.employerLongevityContributionAmount, { required: false });
            var adjustPensionSalaryByContributionsCheckBox = batchAdjustmentForm.js(jsSelectors.adjustPensionSalaryByContributionsCheckBox, { required: false });
            var adjustPensionSalaryByNewAmountCheckBox = batchAdjustmentForm.js(jsSelectors.adjustPensionSalaryByNewAmountCheckBox, { required: false });
            var pensionSalaryAmount = batchAdjustmentForm.js(jsSelectors.pensionSalaryAmount, { required: false });
            var adjustLongevitySalaryCheckBox = batchAdjustmentForm.js(jsSelectors.adjustLongevitySalaryCheckBox, { required: false });
            var longevitySalaryAmount = batchAdjustmentForm.js(jsSelectors.longevitySalaryAmount, { required: false });

            // enable/disable New Member Contribution Amount based on whether Adjust Member Contributions is checked
            adjustMemberContributionsCheckBox.change(function () {
                if (!adjustMemberContributionsCheckBox.is(":checked")) {
                    memberContributionAmount.val("");
                }
                memberContributionAmount.prop("disabled", !adjustMemberContributionsCheckBox.is(":checked"));
            });

            // enable/disable New Longevity Contribution Amount based on whether Adjust Longevity Contributions is checked
            adjustLongevityContributionsCheckBox.change(function () {
                if (!adjustLongevityContributionsCheckBox.is(":checked")) {
                    longevityContributionAmount.val("");
                }
                longevityContributionAmount.prop("disabled", !adjustLongevityContributionsCheckBox.is(":checked"));
            });

            // enable/disable New Employer Contribution Amount based on whether Adjust Employer Contributions is checked
            adjustEmployerContributionsCheckBox.change(function () {
                if (!adjustEmployerContributionsCheckBox.is(":checked")) {
                    employerContributionAmount.val("");
                }
                employerContributionAmount.prop("disabled", !adjustEmployerContributionsCheckBox.is(":checked"));
            });

            // enable/disable New Employer Longevity Contribution Amount based on whether Adjust Employer Contributions is checked
            adjustEmployerLongevityContributionsCheckBox.change(function () {
                if (!adjustEmployerLongevityContributionsCheckBox.is(":checked")) {
                    employerLongevityContributionAmount.val("");
                }
                employerLongevityContributionAmount.prop("disabled", !adjustEmployerLongevityContributionsCheckBox.is(":checked"));
            });

            // enable/disable fields based on whether Adjust Pension Salary by Contribution is checked
            adjustPensionSalaryByContributionsCheckBox.change(function () {
                if (adjustPensionSalaryByContributionsCheckBox.is(":checked")) {
                    adjustPensionSalaryByNewAmountCheckBox.prop("checked", false);
                    pensionSalaryAmount.val("");
                    pensionSalaryAmount.prop("disabled", true);
                }
            });

            // enable/disable fields based on whether Adjust Pension Salary by New Amount is checked
            adjustPensionSalaryByNewAmountCheckBox.change(function () {
                if (adjustPensionSalaryByNewAmountCheckBox.is(":checked")) {
                    adjustPensionSalaryByContributionsCheckBox.prop("checked", false);
                    pensionSalaryAmount.prop("disabled", false);
                }
                else {
                    pensionSalaryAmount.val("");
                    pensionSalaryAmount.prop("disabled", true);
                }
            });

            // enable/disable New Longevity Salary based on whether Adjust Longevity Salary is checked
            adjustLongevitySalaryCheckBox.change(function () {
                if (!adjustLongevitySalaryCheckBox.is(":checked")) {
                    longevitySalaryAmount.val("");
                }
                longevitySalaryAmount.prop("disabled", !adjustLongevitySalaryCheckBox.is(":checked"));
            });

            // show the loading spinner when loading the grid if the form is valid
            submitButton.on("click", function () {
                if (batchAdjustmentForm.valid()) {
                    loadingSpinner.show();
                }
            })
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);